/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalPersonResultResource
 */
export interface LegalPersonResultResource {
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    birthCity?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    birthZipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    birthCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResultResource
     */
    nationalityCountryCode?: string;
}

/**
 * Check if a given object implements the LegalPersonResultResource interface.
 */
export function instanceOfLegalPersonResultResource(value: object): value is LegalPersonResultResource {
    return true;
}

export function LegalPersonResultResourceFromJSON(json: any): LegalPersonResultResource {
    return LegalPersonResultResourceFromJSONTyped(json, false);
}

export function LegalPersonResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalPersonResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'birthCity': json['birthCity'] == null ? undefined : json['birthCity'],
        'birthZipCode': json['birthZipCode'] == null ? undefined : json['birthZipCode'],
        'birthCountryCode': json['birthCountryCode'] == null ? undefined : json['birthCountryCode'],
        'nationalityCountryCode': json['nationalityCountryCode'] == null ? undefined : json['nationalityCountryCode'],
    };
}

export function LegalPersonResultResourceToJSON(value?: LegalPersonResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthDate': value['birthDate'],
        'birthCity': value['birthCity'],
        'birthZipCode': value['birthZipCode'],
        'birthCountryCode': value['birthCountryCode'],
        'nationalityCountryCode': value['nationalityCountryCode'],
    };
}

